<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">

        <div class="left mr-lg-32">

            <div class="pb-24 font-size-18 font-weight-300">
                {{'How are your users buying over time?'|translate}}
            </div>

            <div class="pb-24 font-size-18 font-weight-300">
                <button (click)="today()" mat-raised-button class="mr-8" color="accent">{{'Today'|translate}}</button>
                <button (click)="yesterday()" mat-raised-button class="mr-8"
                        color="accent">{{'Yesterday'|translate}}</button>
                <button (click)="lastWeek()" mat-raised-button class="mr-8"
                        color="accent">{{'Last week'|translate}}</button>
                <button (click)="lastMonth()" mat-raised-button class="mr-8"
                        color="accent">{{'Last month'|translate}}</button>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <!-- Widget 2 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="33">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16">
                                <div class="h3 secondary-text">{{'Date range'|translate}}</div>
                                <div class="font-size-40 font-weight-300 line-height-1 mt-8">
                                    <form [formGroup]="dateRange">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Start date</mat-label>
                                            <input matInput formControlName="start" [matDatepicker]="picker"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>End date</mat-label>
                                            <input matInput formControlName="end" [matDatepicker]="picker2"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                            <mat-datepicker #picker2></mat-datepicker>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="widget" fxFlex="100" fxFlex.gt-sm="33">

                <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                    <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">

                    <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="h2 pr-16">
                            {{ 'Vouchers'|translate }}
                        </div>
                    </div>

                    <table class="simple clickable">
                        <thead>
                        <tr>
                            <th>{{'Name'|translate}}</th>
                            <th class="text-right">{{'Quantity'|translate}}</th>
                            <th class="text-right">{{'Wartość brutto'|translate}}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let row of topVouchers">
                            <td>{{row.name}}</td>
                            <td class="text-right">{{row.vouchersQuantity}}</td>
                            <td class="text-right">{{row.vouchersGrossValue}} zł</td>
                        </tr>
                        </tbody>
                    </table>

                    <div class="card-divider full-width"></div>

                    <!--                        <div class="p-8 pt-16" fxLayout="row" fxLayoutAlign="start center">-->
                    <!--                            <button mat-button color="accent">GO TO CAMPAIGNS</button>-->
                    <!--                        </div>-->

                </div>

            </div>
            </div>

        </div>

    </div>

</div>
